import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { Button } from '#/modules/commonComponents/button';
import {
  AFTERSALES_OPS_PAGE_CONFIG,
  getAftersalesOpsFormNavItems,
} from '#/modules/crmMgmt/aftersales/helper/aftersalesOpsNavConfig';

const AftersalesOpsPageHeader = ({
  page,
  variant,
  title: titleOverride = null,
  statusSlot = null,
  trailing = null,
}) => {
  const { title: configTitle } = AFTERSALES_OPS_PAGE_CONFIG[page];
  const title = titleOverride ?? configTitle;

  if (variant === 'list') {
    return (
      <h1 className="page_title flex flex-wrap items-center gap-2">
        <span className="border-l-5 border-primary-400 pl-2.5">{title}</span>
        {statusSlot}
        {trailing}
      </h1>
    );
  }

  const navItems = getAftersalesOpsFormNavItems(page);

  return (
    <div className="create_edit_page__header">
      <h1 className="page_title mb-0!">
        <span className="border-l-5 border-primary-400 pl-2.5">{title}</span>
      </h1>
      <div className="flex flex-wrap items-center gap-2">
        {navItems.map((item) => (
          <Button
            key={item.label}
            type="button"
            variant={item.variant ?? 'outline'}
            asChild
          >
            <Link to={item.to}>{item.label}</Link>
          </Button>
        ))}
        {trailing}
        {statusSlot}
      </div>
    </div>
  );
};

AftersalesOpsPageHeader.propTypes = {
  page: PropTypes.oneOf([
    'repairRequest',
    'repairItem',
    'repairReport',
    'signReceipt',
    'snProductMapping',
  ]).isRequired,
  variant: PropTypes.oneOf(['list', 'form']).isRequired,
  title: PropTypes.string,
  statusSlot: PropTypes.node,
  trailing: PropTypes.node,
};

export default AftersalesOpsPageHeader;
